import { create } from 'zustand';

interface NetworkState {
  serverReachable: boolean;
  setServerReachable: (value: boolean) => void;
}

export const useNetworkStore = create<NetworkState>((set) => ({
  serverReachable: true,
  setServerReachable: (value) => set({ serverReachable: value }),
}));
